import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';

export type AlertType = 'danger' | 'warning' | 'success' | 'info';

@Component({
    selector: 'xui-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule, MatButtonModule]
})
export class AlertComponent {
  readonly type = input<AlertType>('info');
  readonly message = input('');
  readonly dismissible = input(true);
  readonly icon = input('');
  readonly dismissed = output<void>();

  get alertIcon(): string {
    if (this.icon()) {
      return this.icon();
    }
    switch (this.type()) {
      case 'danger':
        return 'error';
      case 'warning':
        return 'warning';
      case 'success':
        return 'check_circle';
      case 'info':
      default:
        return 'info';
    }
  }

  dismiss(): void {
    this.dismissed.emit();
  }
}
